export default __webpack_public_path__ + "static/media/mass_street_store.8cff912a.jpg";